module.exports = __webpack_public_path__ + "img/arrow-1.ff50c463.png";